import api from '@/api/microsoftGraph'

const state = {

}

const actions = {
  checkMicrosoftGraphAuth () {
    return api.checkMicrosoftGraphAuth()
  },
  createOnlineMeetingEvent ({ commit }, params) {
    return api.createOnlineMeetingEvent(params)
  },
  updateOnlineMeetingEvent ({ commit }, params) {
    return api.updateOnlineMeetingEvent(params)
  },
  deleteOnlineMeetingEvent ({ commit }, { eventId }) {
    return api.deleteOnlineMeetingEvent(eventId)
  }
}

const mutations = {

}

const getters = {

}
export default {
  namespaced: true,
  state,
  actions,
  mutations,
  getters
}
